{
	"home": {
		"page_title": "Dashboard"
	}
}
